<div id="divChart" class="divChart">
  <h4>{{day}}</h4>
  <h6 *ngIf="dateDiff > 7"> Moyenne du {{dateStart | date: "shortDate"}} au {{dateEnd | date: "shortDate"}}</h6>
  <h6 *ngIf="dateDiff <= 7"> Date du {{dateLabel | date: "shortDate"}} </h6>

  <div class="infos" *ngIf="getSum() > 0">
    <fa-icon [icon]="faInfoCircle"></fa-icon>
    <div class="infos_content">
      <p>{{infoBubble}}</p>
    </div>
  </div>

  <div class="no_data" *ngIf="getSum() === 0">
    <p>Aucune donnée </p>
  </div>
  <div class="chart" *ngIf="getSum() > 0">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
      [legend]="barChartLegend" [chartType]="barChartType" label="heures"> </canvas>

    <div class="label_orderly">{{labelOrderly}}</div>
  </div>
</div>